import { __awaiter } from "tslib";
import { FacadeRegistry } from './facade-registry';
import { WebPlugin } from './web-plugin';
import { JWebWeb } from './web-runtime';
var jWebHasResolved = false;
export const WhenJWebReady = new Promise((resolve) => {
    console.log('global::WhenJWebReady: Initialize');
    let timeout;
    // The bridge timeout triggers too early roughly 50% of the time on older versions of Android
    // (check on an Android 24 emulator), so we need to retry it a few times to make it safer.
    const bridgeTimeoutRetries = 2;
    // The bridge timeout duration is set to zero so that the timeout function is simply pushed to
    // the back of the execution stack.
    const bridgeTimeoutDuration = 0;
    // The bridge timeout duration is incremented slightly each retry so that subsequent timeouts
    // allow for a bigger bridge injection window.
    const bridgeTimeoutIncrement = 25;
    const globalThis = typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
    var JWeb = globalThis.JWeb;
    function resolveJWeb() {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof window !== "undefined" && window && window.removeEventListener) {
                window.removeEventListener('jWebReady', resolveJWeb, false);
            }
            clearTimeout(timeout);
            yield FacadeRegistry.adaptJWeb(globalThis.JWeb);
            const Plugins = JWeb.Plugins;
            console.log('global::WhenJWebReady: Ready!');
            jWebHasResolved = true;
            resolve({ JWeb, Plugins });
        });
    }
    function setBridgeTimeout(retries, duration, increment) {
        timeout = setTimeout(() => {
            if (globalThis.JWeb === undefined) {
                if (retries) {
                    setBridgeTimeout(retries - 1, duration + increment, increment);
                }
                else {
                    // Create a new JWebWeb instance if one doesn't already exist on globalThis
                    // Ensure the global is assigned the same JWeb instance,
                    // then export JWeb so it can be imported in other modules
                    JWeb = new JWebWeb();
                    globalThis.JWeb = JWeb;
                    globalThis.Plugins = JWeb.Plugins;
                    webPluginsToRegister.forEach((pluginWrapper) => {
                        console.log('Registering the web plugin: ' + pluginWrapper.pluginName);
                        JWeb.Plugins[pluginWrapper.pluginName] = pluginWrapper.pluginInstance;
                    });
                    webPluginsToRegister = [];
                    resolveJWeb();
                }
            }
        }, duration);
    }
    // This first check is opportunistic,
    // where the timing implies that the Bridge has already injected
    // and fired the 'jWebReady' event.
    // In this case, JWeb should be available in the global scope..
    if (globalThis.JWeb !== undefined) {
        resolveJWeb();
    }
    else {
        // If JWeb is not in the global scope yet,
        // Add a listener for the 'jWebReady' event that is fired during bridge injection.
        if (typeof window !== "undefined" && window) {
            window.addEventListener('jWebReady', resolveJWeb);
        }
        // Set a timeout if the bridge does not appear.
        setBridgeTimeout(bridgeTimeoutRetries, bridgeTimeoutDuration, bridgeTimeoutIncrement);
    }
});
var webPluginsToRegister = [];
export const registerPlugin = (name, plugin) => {
    console.log('Register plugin has been called for plugin with name: ' + name);
    const globalThis = typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
    var JWeb = globalThis.JWeb;
    var registeredPlugin = plugin;
    if (JWeb === undefined) {
        // JWeb has not been injected yet. Either the 'web' version, nor the native version...
        // Preemptively add this plugin to the web plugins that can be registered..
        webPluginsToRegister.push({ pluginInstance: plugin, pluginName: name });
    }
    else if (JWeb.Plugins && JWeb.Plugins[name] && Object.keys(JWeb.Plugins[name]).length === 0) {
        console.log('Plugin has not been injected yet with name: ' + name);
        if (JWeb.platform === 'web' && plugin instanceof WebPlugin) {
            console.log('Injecting web plugin with name: ' + name);
            if (jWebHasResolved) {
                JWeb.Plugins[name] = plugin;
            }
            else {
                // JWeb has not resolved yet, handle race condition..
                webPluginsToRegister.push({ pluginInstance: plugin, pluginName: name });
            }
        }
    }
    else {
        registeredPlugin = JWeb.Plugins[name];
    }
    return registeredPlugin;
};
//# sourceMappingURL=global.js.map